module.exports = __webpack_public_path__ + "static/media/phone.fd7c079e.svg";